import { clsx } from 'clsx'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { analyticsNumberFormatter } from '../utils/parser.js'

interface Props {
  current: number | string
  previous?: number | string
  isLoading: boolean
}

export const Score = ({ current, previous, isLoading }: Props) => {
  const getDiff = (current: string | number, previous: string | number) => {
    if (current === '' || previous === '') {
      return { diff: 0, format: '' }
    }

    const val1 = +current
    const val2 = +previous

    if (
      Number.isNaN(val1) ||
      Number.isNaN(val2) ||
      !Number.isFinite(val1) ||
      !Number.isFinite(val2)
    ) {
      return { diff: 0, format: '' }
    }

    if (val2 === 0) {
      return { diff: val1 - val2, format: '' }
    }

    const diff = ((val1 - val2) / val2) * 100

    if (diff < 10000) {
      return { diff, format: '%' }
    }

    return { diff: 0, format: '' }
  }

  const { diff, format } = getDiff(current, previous)

  return (
    <div className={isLoading ? 'opacity-30' : ''}>
      <div className="flex items-center space-s-1">
        <div className="text-heading-sm text-content">
          {isLoading ? '-' : analyticsNumberFormatter(current)}
        </div>
        {(diff !== 0 || format !== '') && (
          <div
            className={clsx(
              'h-3 flex items-center text-sm',
              diff > 0 ? 'text-content-on-positive' : 'text-action-destructive',
            )}
          >
            {!isLoading ? (
              <>
                {diff > 0 && <SvgIcon className="w-3" name="arrow-up" />}
                {diff < 0 && <SvgIcon className="w-3" name="arrow-down" />}
                {analyticsNumberFormatter(Math.abs(diff))}
                {format}
              </>
            ) : (
              ' '
            )}
          </div>
        )}
      </div>
    </div>
  )
}
